<mat-card>
  <mat-card-header>
      <img mat-card-avatar class="accessory-box-img"
           [src]="'/files/cassonetto/' + cassonetto?.image"
           [alt]="cassonetto?.name"
           defaultImg>
      <mat-card-title class="accessory-box-title">{{cassonetto?.name}}
      </mat-card-title>
      <mat-card-subtitle class="cassonetto-box-description">
          {{cassonetto?.description}}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
      <form [formGroup]="form">
         <div>
            <span>
                {{ 'ACCESSORY|Kolor' | translate }}: <b>{{ cassonetto?.color?.name }} </b>
            </span>
            <div class="options-buttons">
                <button mat-stroked-button color="primary"
                    (click)="openModalColors()">{{ 'INTERFACE|Zmień' | translate }}
                </button>
            </div>
        </div>

          <mat-form-field [class.mat-form-field-invalid]="currentWidthControl?.invalid && currentWidthControl?.touched">
              <mat-label>L</mat-label>
              <input matInput iccDimensionInput formControlName="currentWidth" type="number">
              <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
              @if (currentWidthControl?.hasError('min')) {
                  <mat-error>
                      {{ 'CONFIGURATOR|Minimalna wartość' | translate }}: {{currentWidthControl?.errors?.min?.min}}mm
                  </mat-error>
              }
              @if (currentWidthControl?.hasError('max')) {
                  <mat-error>
                      {{ 'CONFIGURATOR|Maksymalna wartość' | translate }}: {{currentWidthControl?.errors?.max?.max}}mm
                  </mat-error>
              }
          </mat-form-field>

          @if (!isCelinoMode()) {
              <mat-form-field [class.mat-form-field-invalid]="currentHeightControl?.invalid && currentHeightControl?.touched">
                  <mat-label>H</mat-label>
                  <input matInput iccDimensionInput formControlName="currentHeight" type="number">
                  <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
                  @if (currentHeightControl?.hasError('min')) {
                      <mat-error>
                          {{ 'CONFIGURATOR|Minimalna wartość' | translate }}: {{currentHeightControl?.errors?.min?.min}}mm
                      </mat-error>
                  }
                  @if (currentHeightControl?.hasError('max')) {
                      <mat-error>
                          {{ 'CONFIGURATOR|Maksymalna wartość' | translate }}: {{currentHeightControl?.errors?.max?.max}}mm
                      </mat-error>
                  }
              </mat-form-field>
          }

          @if (isCelinoMode() || pageData.cassonettoData?.showP1 == 1) {
              <mat-form-field [class.mat-form-field-invalid]="currentP1Control?.invalid && currentP1Control?.touched">
                  <mat-label>P1</mat-label>
                  <input matInput iccDimensionInput formControlName="currentP1" type="number">
                  <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
                  @if (currentP1Control?.hasError('min')) {
                      <mat-error>
                          {{ 'CONFIGURATOR|Minimalna wartość' | translate }}: {{currentP1Control?.errors?.min?.min}}mm
                      </mat-error>
                  }
                  @if (currentP1Control?.hasError('max')) {
                      <mat-error>
                          {{ 'CONFIGURATOR|Maksymalna wartość' | translate }}: {{currentP1Control?.errors?.max?.max}}mm
                      </mat-error>
                  }
                  @if (!isCelinoMode() && pageData.cassonettoData?.defaultP1 && currentP1Control?.valid) {
                      <mat-hint>
                          {{ 'CONFIGURATOR|Domyślna' | translate }}: {{pageData.cassonettoData.defaultP1}}mm
                          @if (currentP1Control?.value < pageData.cassonettoData?.defaultP1 && pageData.cassonettoData?.allowDepthCuttingP1) {
                              <span style="color: #e67e22;">
                                  ({{ 'CONFIGURATOR|dopłata za przycięcie' | translate }})
                              </span>
                          }
                          @if (currentP1Control?.value > pageData.cassonettoData?.defaultP1 && currentP1Control?.value < pageData.cassonettoData?.maxP1Mm && pageData.cassonettoData?.allowDepthIncreaseP1) {
                              <span style="color: #e67e22;">
                                  ({{ 'CONFIGURATOR|dopłata za zwiększenie i skracanie głębokości' | translate }})
                              </span>
                          }
                          @if (currentP1Control?.value === pageData.cassonettoData?.maxP1Mm && pageData.cassonettoData?.allowDepthIncreaseP1) {
                              <span style="color: #e67e22;">
                                  ({{ 'CONFIGURATOR|dopłata za zwiększenie głębokości' | translate }})
                              </span>
                          }
                      </mat-hint>
                  }
              </mat-form-field>
          }
          @if (pageData.cassonettoData?.showP2 == 1) {
              <mat-form-field [class.mat-form-field-invalid]="currentP2Control?.invalid && currentP2Control?.touched">
                  <mat-label>P2</mat-label>
                  <input matInput iccDimensionInput formControlName="currentP2" type="number">
                  <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
                  @if (currentP2Control?.hasError('min')) {
                      <mat-error>
                          {{ 'CONFIGURATOR|Minimalna wartość' | translate }}: {{currentP2Control?.errors?.min?.min}}mm
                      </mat-error>
                  }
                  @if (currentP2Control?.hasError('max')) {
                      <mat-error>
                          {{ 'CONFIGURATOR|Maksymalna wartość' | translate }}: {{currentP2Control?.errors?.max?.max}}mm
                      </mat-error>
                  }
                  @if (pageData.cassonettoData?.defaultP2 && currentP2Control?.valid) {
                      <mat-hint>
                          {{ 'CONFIGURATOR|Domyślna' | translate }}: {{pageData.cassonettoData.defaultP2}}mm
                          @if (currentP2Control?.value < pageData.cassonettoData?.defaultP2 && pageData.cassonettoData?.allowDepthCuttingP2) {
                              <span style="color: #e67e22;">
                                  ({{ 'CONFIGURATOR|dopłata za przycięcie' | translate }})
                              </span>
                          }
                          @if (currentP2Control?.value > pageData.cassonettoData?.defaultP2 && currentP2Control?.value < pageData.cassonettoData?.maxP2Mm && pageData.cassonettoData?.allowDepthIncreaseP2) {
                              <span style="color: #e67e22;">
                                  ({{ 'CONFIGURATOR|dopłata za zwiększenie i skracanie głębokości' | translate }})
                              </span>
                          }
                          @if (currentP2Control?.value === pageData.cassonettoData?.maxP2Mm && pageData.cassonettoData?.allowDepthIncreaseP2) {
                              <span style="color: #e67e22;">
                                  ({{ 'CONFIGURATOR|dopłata za zwiększenie głębokości' | translate }})
                              </span>
                          }
                      </mat-hint>
                  }
              </mat-form-field>
          }
          <mat-form-field>
              <input matInput type="number" min="1"
                    [placeholder]="'INTERFACE|Ilość' | translate"
                    formControlName="count">
          </mat-form-field>

          <!-- Opcja bez płyty czołowej -->
          @if (pageData.cassonettoData?.noFrontPlateAvailable) {
              <div style="margin: 15px 0;">
                  <mat-checkbox formControlName="withoutFrontPlate">
                      {{ 'CONFIGURATOR|Bez płyty czołowej' | translate }}
                  </mat-checkbox>
              </div>
          }

          <h4>{{ 'OFFER|Cena' | translate }}:
              {{ currentPrice$ | async | currency : currency }}</h4>
      </form>
  </mat-card-content>
  <mat-card-actions>
      <button mat-raised-button color="primary" (click)="add()"
              [disabled]="!canAdd()">{{ 'INTERFACE|Dodaj' | translate }}</button>
  </mat-card-actions>


</mat-card>
